import { createSlice } from '@reduxjs/toolkit';
import { useAppDispatch } from '@services/state/store';
import React from 'react';

type OverlayState = {
  overlays: string[];
  scrollPosition: number;
};

const slice = createSlice({
  name: 'overlays',
  initialState: {
    overlays: [],
    scrollPosition: 0,
  } as OverlayState,
  reducers: {
    addOverlay: (state, action) => {
      if (state.overlays.indexOf(action.payload) >= 0) return;
      state.overlays.push(action.payload);
      state.scrollPosition = disableBodyScroll();
    },
    removeOverlay: (state, action) => {
      const idx = state.overlays.indexOf(action.payload);
      if (idx < 0) return;
      state.overlays = state.overlays.filter((x) => x !== action.payload);
      if (state.overlays.length === 0) enableBodyScroll(state.scrollPosition);
    },
  },
});

let recentTop: number = 0;
export const disableBodyScroll = () => {
  if (document.body.classList.contains('no-scroll')) return recentTop;

  recentTop = window.scrollY;
  document.body.classList.add('no-scroll');
  document.body.style.top = `-${recentTop}px`;
  return recentTop;
};

export const enableBodyScroll = (pos: number) => {
  document.body.classList.remove('no-scroll');
  document.body.style.top = '';
  window.scrollTo(0, pos);
  recentTop = 0;
};

const overlaysActions = slice.actions;
export const overlaysReducer = slice.reducer;

export type OverlayControlHook = {
  addOverlay: (name: string) => void;
  removeOverlay: (name: string) => void;
};

export const useOverlayControl = (): OverlayControlHook => {
  const dispatch = useAppDispatch();

  const add = React.useCallback((name: string) => dispatch(overlaysActions.addOverlay(name)), []);

  const del = React.useCallback((name: string) => dispatch(overlaysActions.removeOverlay(name)), []);

  return {
    addOverlay: add,
    removeOverlay: del,
  };
};
